import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_ORIGIN = new URL(process.env.REACT_APP_PUBLIC_SITE_URL).origin;

// Un seul responsable des balises de chaque route : évite le conflit de
// hoisting des métadonnées entre React 19, Helmet et le head statique CRA.
export const Seo = ({ title, description, faq, noindex = false }) => {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    document.title = title;
    const setMeta = (attribute, key, value) => {
      const matches = [...document.head.querySelectorAll(`meta[${attribute}="${key}"]`)];
      const tag = matches.shift() || document.createElement('meta');
      matches.forEach(duplicate => duplicate.remove());
      tag.setAttribute(attribute, key);
      tag.setAttribute('content', value);
      tag.removeAttribute('data-rh');
      if (!tag.isConnected) document.head.appendChild(tag);
    };
    setMeta('name', 'description', description);
    setMeta('name', 'robots', noindex ? 'noindex, follow' : 'index, follow, max-image-preview:large');
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);
    const siteUrl = SITE_ORIGIN;
    const path = pathname === '/' ? '/' : pathname.replace(/\/+$/, '');
    const canonicalUrl = `${siteUrl}${path}`;
    const canonicalTags = [...document.head.querySelectorAll('link[rel="canonical"]')];
    const canonical = canonicalTags.shift() || document.createElement('link');
    canonicalTags.forEach(tag => tag.remove());
    canonical.setAttribute('rel', 'canonical');
    canonical.setAttribute('href', canonicalUrl);
    if (!canonical.isConnected) document.head.appendChild(canonical);
    setMeta('property', 'og:url', canonicalUrl);
    setMeta('property', 'og:image', `${siteUrl}/batisey-partage.png`);
    setMeta('name', 'twitter:image', `${siteUrl}/batisey-partage.png`);
    document.getElementById('batisey-faq-schema')?.remove();
    if (faq) {
      const script = document.createElement('script');
      script.id = 'batisey-faq-schema';
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify({ '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: faq.map(({ q, a }) => ({ '@type': 'Question', name: q, acceptedAnswer: { '@type': 'Answer', text: a } })) });
      document.head.appendChild(script);
    }
  }, [title, description, faq, noindex, pathname]);
  return null;
};